/**
 * Ticket 2 — Single shared published-catalog load for the customer homepage.
 * Tours + Top Countries (and any future homepage slices) share one network call.
 */

import {
  getPublishedProducts,
  transformProductForFrontend,
} from "./productService";

/** Covers tours (8) + top-countries (12) without a second query key. */
export const HOMEPAGE_CATALOG_PAGE_SIZE = 12;

let cachedProducts = null;
let inflight = null;

/**
 * Load homepage catalog once; concurrent callers share the same promise.
 * @param {{ force?: boolean }} [opts]
 * @returns {Promise<{ products: object[] }>}
 */
export async function loadHomepageCatalog(opts = {}) {
  const force = opts.force === true;
  if (force) {
    cachedProducts = null;
  }
  if (cachedProducts) {
    return { products: cachedProducts };
  }
  if (inflight) {
    return inflight;
  }

  inflight = (async () => {
    const data = await getPublishedProducts({
      page: 1,
      page_size: HOMEPAGE_CATALOG_PAGE_SIZE,
    });
    const list = (data?.products || []).map(transformProductForFrontend);
    cachedProducts = list;
    return { products: list };
  })().finally(() => {
    inflight = null;
  });

  return inflight;
}

/** Test / diagnostics */
export function getHomepageCatalogCacheForTests() {
  return cachedProducts;
}

/** Test / diagnostics */
export function resetHomepageCatalogForTests() {
  cachedProducts = null;
  inflight = null;
}
